import React from 'react';
import { Features } from './components/Features';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Pricing';
export function App() {
  return <div className="extensions-page min-h-screen bg-cream font-sans text-brand-900 selection:bg-brand-500 selection:text-white" data-id="element-0" data-mp="3k89sdu7kovif">
      <MetaPixel data-id="element-1" data-mp="3f8ex7egrljrk" />
      <Hero data-id="element-2" data-mp="2rkx5fixi2lol" />
      <Features data-id="element-3" data-mp="2rkdw2qlx15m6" />
      <Pricing data-id="element-4" data-mp="2rlyreig20sl3" />
    </div>;
}